module.exports = __webpack_public_path__ + "static/img/bg-pic.99a5827.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/TiiVii/bg-pic.png
// module id = qunl
// module chunks = 0